/* Common Imports */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

/* Component Imports */
import { Card, CardMedia, CardContent, Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../AppConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    boxShadow:
      "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
    borderRadius: "0.375rem",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "30%",
    },
    [theme.breakpoints.only("md")]: {
      width: "30%",
    },
    [theme.breakpoints.only("lg")]: {
      width: "30%",
    },
    [theme.breakpoints.only("xl")]: {
      width: "30%",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      width: "30%",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 920)]: {
      width: "15%",
    },
  },
  media: {
    margin: "0.5rem 0rem 0rem 0rem",
    backgroundSize: "auto",
  },
  infotitle: {
    fontWeight: "600",
    fontSize: "1.5rem",
    lineHeight: "1.875rem",
    marginTop: "0.5em",
  },
  infotext: {
    fontWeight: "400",
    lineHeight: "1.25rem",
    color: "#18191F",
    marginTop: "1rem",
    [theme.breakpoints.up("lg")]: {
      fontSize: "1rem",
    },
  },
  content: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  ul: {
    marginTop: "0rem",
    paddingLeft: "1.5rem",
    wordBreak: "break-word",
  },
  listItem: {
    color: "#666666",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.3rem",
    letterSpacing: "0.009rem",
  },
}));

const ClassCard = (props) => {
  const classes = useStyles();
  return (
    <Card
      className={clsx(
        classes.root,
        props.cardClass ? props.cardClass : classes.cardClass
      )}
      style={{
        height: props.height ? props.height : "23.625rem",
        width: props.width ? props.width + " !important" : undefined,
      }}
    >
      <CardMedia className={classes.media}>
        <img
          decode="async"
          alt={AppConfig.imageAltText}
          longdesc="https://advisory.beegru.com"
          loading="lazy"
          referrerPolicy="no-referrer"
          height={110}
          width={110}
          src={props.icon ? props.icon : "/images/icons/social/location.svg"}
        />
      </CardMedia>
      <CardContent className={classes.content}>
        <Typography
          variant="h6"
          component="h6"
          align="center"
          className={classes.infotitle}
        >
          {props.heading}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          align="center"
          className={classes.infotext}
        >
          <ul className={classes.ul}>
            {props.subHeading
              ? props.subHeading.map((object, key) => (
                  <li key={key} className={classes.listItem}>
                    {object}
                  </li>
                ))
              : "Unable to fetch data :("}
          </ul>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ClassCard;
